import { IStudentsFilterDto } from '@sdk/contracts';
import { useQuery } from '@tanstack/react-query';
import { create as createStore } from 'zustand';

import { sdk } from '@/services';

const INITIAL_PAGE = 1;
const INITIAL_LIMIT = 50;

const MyAcademyStudentsService = sdk.getService('MyAcademyStudentsService');

interface IStore {
  page: number;
  limit: number;
  search: string;
  filter?: IStudentsFilterDto;
  setFilter: (filter?: IStudentsFilterDto) => void;
  setSearch: (search: string) => void;
  setPageAndLimit: (page: number, limit: number) => void;
}

const store = createStore<IStore>(set => ({
  page: INITIAL_PAGE,
  limit: INITIAL_LIMIT,
  search: '',
  setFilter: (filter?: IStudentsFilterDto) =>
    set(state => ({ ...state, page: INITIAL_PAGE, filter })),
  setSearch: (search: string) => set(state => ({ ...state, search, page: INITIAL_PAGE })),
  setPageAndLimit: (page: number, limit: number) => set(state => ({ ...state, page, limit }))
}));

export const useStudentsList = (bypass = false) => {
  const { page, limit, search, filter, setFilter, setSearch, setPageAndLimit } = store();

  const queryKey = [
    'students',
    `page-${page}`,
    `limit-${limit}`,
    search,
    `bypass-${bypass}`,
    filter
  ];
  const { isLoading, data, error } = useQuery({
    queryKey,
    queryFn: () => MyAcademyStudentsService.getStudents(search, { page, limit }, bypass, filter)
  });

  const resetSearchResults = () => setSearch('');

  const pagination = data && {
    page: data.page,
    limit: data.limit,
    hasNextPage: data.hasNextPage,
    hasPrevPage: data.hasPrevPage,
    nextPage: data.nextPage,
    pagingCounter: data.pagingCounter,
    prevPage: data.prevPage,
    totalDocs: data.totalDocs,
    totalPages: data.totalPages
  };

  return {
    students: data?.docs,
    isLoading,
    error,
    setPageAndLimit,
    pagination,
    filter,
    setSearch,
    setFilter,
    resetSearchResults
  };
};
